import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutMission from './components/AboutMission';
import AboutValues from './components/AboutValues';
import AboutMap from './components/AboutMap';
import AboutCTA from './components/AboutCTA';

const ABOUT_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/about#webpage`,
      url: `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/about`,
      name: 'Sobre Nosotros | ORPM Investment LLC – Empresa de Confianza en Georgia',
      description: 'Conoce a ORPM Investment LLC, empresa líder en purificación de agua e instalación de ventanas en Georgia. Nuestra misión, valores y compromiso con la calidad.',
      inLanguage: 'es-US',
      isPartOf: {
        '@type': 'WebSite',
        url: import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com',
        name: 'ORPM Investment LLC',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/#organization`,
      name: 'ORPM Investment LLC',
      url: import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com',
      telephone: '+15615122820',
      email: 'info@orpminvestment.com',
      foundingLocation: {
        '@type': 'Place',
        name: 'Lawrenceville, Georgia, USA',
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '3202 Lealand Pl Ln',
        addressLocality: 'Lawrenceville',
        addressRegion: 'GA',
        postalCode: '30044',
        addressCountry: 'US',
      },
      description: 'Empresa especializada en sistemas de purificación de agua e instalación de ventanas de alta eficiencia en Georgia.',
    },
  ],
};

export default function AboutPage() {
  useEffect(() => {
    const id = 'schema-about';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(ABOUT_SCHEMA);
    document.title = 'Sobre Nosotros | ORPM Investment LLC – Georgia';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Conoce a ORPM Investment LLC, empresa líder en purificación de agua e instalación de ventanas en Georgia. Nuestra misión, valores y compromiso con la calidad.');
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <AboutHero />
        <AboutMission />
        <AboutValues />
        <AboutMap />
        <AboutCTA />
      </main>
      <Footer />
    </div>
  );
}
